import React, { createContext, useContext, useState } from 'react';

const CompareContext = createContext();

export const CompareProvider = ({ children }) => {
    const [showCompareSelectionModal, setShowCompareSelectionModal] = useState(false);
    const [selectedRecipes, setSelectedRecipes] = useState([]);
    const [compareRecipes, setCompareRecipes] = useState([null, null]);
    const [showCompareModal, setShowCompareModal] = useState(false);

    const openCompareSelection = () => {
        setShowCompareSelectionModal(true);
    };

    const closeCompareSelection = () => {
        setShowCompareSelectionModal(false);
        setSelectedRecipes([]);
    };

    const toggleRecipeSelection = (recipe) => {
        setSelectedRecipes(prev => {
            const exists = prev.find(r => r.id === recipe.id);
            if (exists) {
                return prev.filter(r => r.id !== recipe.id);
            } else if (prev.length < 2) {
                return [...prev, recipe];
            }
            return prev;
        });
    };

    const clearSelection = () => {
        setSelectedRecipes([]);
    };

    const openCompareModal = (recipe1, recipe2) => {
        setCompareRecipes([recipe1, recipe2]);
        setShowCompareModal(true);
    };

    const closeCompareModal = () => {
        setShowCompareModal(false);
        setSelectedRecipes([]);
    };

    return (
        <CompareContext.Provider
            value={{
                showCompareSelectionModal,
                openCompareSelection,
                closeCompareSelection,
                selectedRecipes,
                toggleRecipeSelection,
                clearSelection,
                compareRecipes,
                showCompareModal,
                openCompareModal,
                closeCompareModal
            }}
        >
            {children}
        </CompareContext.Provider>
    );
};

export const useCompare = () => {
    const context = useContext(CompareContext);
    if (!context) {
        throw new Error('useCompare must be used within a CompareProvider');
    }
    return context;
};

